import { load_one } from '../action-helpers.js'
import axios from 'axios';

export default {

    loadOne: load_one('proofs/:id'),

    update({ dispatch }, { model }) {
        return axios.put(`/api/v1/proofs/${model.id}`, model).then(() => {
            dispatch('loadOne', { id: model.id, force: true })
        })
    },

}
